import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useRef } from 'react';
import styled from 'styled-components';
import { BigNumber, NumericFormat } from '@blade/std-lib';
export const Numeric = ({ value, preset, ref, style, className, ...props }) => {
    const prevValueRef = useRef(undefined);
    const formattedRef = useRef(_jsx(_Fragment, {}));
    if (prevValueRef.current === undefined ||
        !BigNumber.valueEquivalenceStrict(prevValueRef.current, value)) {
        prevValueRef.current = value;
        const formatted = (() => {
            const options = props;
            const parts = NumericFormat.formatPresetToParts(value, preset, options);
            const elements = parts.map((x, i) => (_jsx(React.Fragment, { children: partToReactElement(x) }, i)));
            return _jsx(React.Fragment, { children: elements });
        })();
        formattedRef.current = formatted;
    }
    return (_jsx(Root, { style: style, className: className, ref: ref, children: formattedRef.current }));
};
const Root = styled.span `
  white-space: nowrap;
`;
const partToReactElement = (part) => {
    if (part.type === 'compact-decimal-zeroes') {
        return _jsx(ZeroCount, { children: part.value });
    }
    return part.value;
};
const ZeroCount = styled.sub `
  font-size: 0.7em;
  font-weight: inherit;
  padding-inline: 1px;
  line-height: 1;
`;
Numeric.displayName = 'Numeric';
//# sourceMappingURL=numeric.js.map